import { ListTranslationKeys } from '../../../api/models/TranslationKeys';
import { ListChannelFilterActionHandler } from '../../../Business/epg/actionHandlers/ListChannelFilterActionHandler';
import { ListDayFilterActionHandler } from '../../../Business/epg/actionHandlers/ListDayFilterActionHandler';
import { ListTagFilterActionHandler } from '../../../Business/epg/actionHandlers/ListTagFilterActionHandler';
import { ListGroupBy } from '../../../Business/epg/EpgListDataSource';

/**
 * @enum {string}
 */
export const listFilterType = {
  channel: 'channel',
  day: 'day',
  tag: 'tag',
  all: 'all',
};

export const filterActionMap = {
  [listFilterType.channel]: ListChannelFilterActionHandler,
  [listFilterType.day]: ListDayFilterActionHandler,
  [listFilterType.tag]: ListTagFilterActionHandler,
};

/**
 * @param {Backend} backend
 */
export function initChannels(backend) {
  this.filterTitle = backend.translations.forKey(ListTranslationKeys.lists_filter_channel);
  backend.cachedChannelApi.validChannels(backend, this.replay).then(result => {
    this.options = result.validChannels.map(channel => ({
      text: channel.text.title,
      value: channel,
    }));
  });
}

export class FilterState {
  constructor(init = {}) {
    this.types = [];
    this.subscriptions = [];
    this.filters = {};
    this._initialState = init;
  }

  subscribe(cb) {
    this.subscriptions.push(cb);
  }

  unsubscribe(cb) {
    this.subscriptions = this.subscriptions.filter(cb1 => cb1 !== cb);
  }

  add(type) {
    if (!this.types.includes(type)) {
      this.types.push(type);
      this.filters[type] = this._initialState[type] ? this._initialState[type] : undefined;
    }
  }

  filtersSet() {
    return Object.keys(this.filters).length > 0;
  }

  reset() {
    this.filters = {};
    // Object.keys(tmp).forEach(key => {
    //   this.subscriptions.forEach(cb => cb(key, undefined));
    // });
    this.subscriptions.forEach(cb => cb(listFilterType.all, undefined));
  }

  updateState(type, stateName, value) {
    this.filters[type] = { text: stateName, value };
    this.subscriptions.forEach(cb => cb(type, this.filters[type]));
  }

  stateOf(type) {
    return this.filters[type];
  }

  /**
   * @returns {IFiltersInfo}
   */
  get state() {
    let channel = this.stateOf(listFilterType.channel);
    channel = channel ? channel.value : undefined;
    let day = this.stateOf(listFilterType.day);
    day = day ? day.value : undefined;
    let tags = this.stateOf(listFilterType.tag);
    tags = tags ? tags.value : undefined;
    return {
      groupBy: channel ? ListGroupBy.day : ListGroupBy.channel,
      channel: channel,
      date: day,
      categories: tags,
    };
  }
}
